import { Component, Vue, Watch } from 'vue-property-decorator';

import { OfflineResMgr } from '@/api/index';

@Component
export default class OfflineRecord extends Vue {
  private searchValue: string = '';
  private recordTableData: object[] = [];
  private page: any = {
    currPage: 1,
    size: 10,
    total: 0,
    sizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper'
  };
  // 表格表头设置
  private columns: object[] = [
    { prop: 'importTime', title: '时间', filter: 'time' },
    { prop: 'fileName', title: '文件名称' },
    { prop: 'operatorName', title: '操作人' }
  ];
  // 初始化
  private created() {
    this.getRecordTableData();
  }
  // 搜索
  private searchBtnClick() {
    this.getRecordTableData();
  }
  // 获取操作记录列表框
  private getRecordTableData(currPage = 1) {
    this.page.currPage = currPage;
    OfflineResMgr.getImportRecordList(this.searchValue, 'offline', this.page.currPage, this.page.size).then(res => {
      this.recordTableData = res.data;
      this.page.total = parseInt(res.headers.total, 10);
    });
  }
  // 表格分页条数Change
  private pageSizeChange(value) {
    this.page.size = value;
    this.getRecordTableData();
  }
  // 表格当前页Change
  private currentPageChange(value) {
    this.getRecordTableData(value);
  }
}
